import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import axios from "axios";
import { toast } from "react-toastify";

import { onClickLogout } from "../../../../../store/user";
import { resetSetting } from "../../../../../store/scheduler";
import { useModal } from "../../../../../hooks/useModal";

import { MembershipWithdrawalContainer } from "../styled/dashboard";
import { SubmitButton } from "../../../styled/mypage";
import { resetCompany } from "../../../../../store/company";

const MembershipWithdrawal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state?.user?.data[0]);
  const setting = useSelector((state) => state?.user?.setting);

  const { modal, openModal, closeModal } = useModal();

  const deleteMber = async () => {
    const url = "/api/mber";
    const body = {
      mberNo: user.mberNo,
      cmpnyNo: user.cmpnyNo,
      username: user.userName,
      // password:'',
      mberNm: user.name,
      email: user.email,
      createMberId: user.userName,
      updateMberId: user.userName,
      delYn: "Y",
    };

    try {
      const res = await axios.put(url, body);

      if (res.data.success) {
        dispatch(onClickLogout());
        dispatch(resetSetting());
        dispatch(resetCompany());
        toast.success("회원 탈퇴가 완료되었습니다.", { toastId: "no-access" });
        navigate("/login");
      }
    } catch (error) {
      toast.error("잠시후 다시 시도해주세요");
    } finally {
      closeModal();
    }
  };

  return (
    <>
      {modal}
      <MembershipWithdrawalContainer className={setting?.mode}>
        <span>※ 탈퇴 전 확인하세요.</span>
        <div className="viewer">
          <span>탈퇴 시 일정, 디데이, 프로필 등</span>
          <span>
            모든 데이터가 <strong>영구 삭제</strong>되며 복구할 수 없습니다.
          </span>
          <span>탈퇴 후 같은 계정으로 재가입하더라도 기존 데이터는 복구되지 않습니다.</span>
          <br />
          <span>모든 내용을 확인하셨다면 아래 버튼을 눌러 탈퇴를 진행해 주세요.</span>
        </div>
        <SubmitButton>
          <button
            onClick={() =>
              openModal({
                isOpen: true,
                type: "confirmation",
                title: `회원 탈퇴`,
                message: ["회원 탈퇴를 진행하시겠습니까?"],
                handleConfirm: () => deleteMber(),
                handleCancel: () => closeModal(),
              })
            }>
            <span>탈퇴하기</span>
          </button>
        </SubmitButton>
      </MembershipWithdrawalContainer>
    </>
  );
};

export default MembershipWithdrawal;
